import React from 'react';
import type { User } from '../../utils/userUtils';
import type { MentionPopupDisplayMode } from '../CommonTooltip/MentionPopup/MentionPopup.types';

interface MentionPopupLayerProps {
  enableMentions: boolean;
  isOpen: boolean;
  users: User[];
  loading: boolean;
  selectedIndex: number;
  position: {
    x: number;
    y: number;
    maxHeight?: number;
    placement: 'above' | 'below';
  };
  query: string;
  mentionPopupStyle?: React.CSSProperties;
  mentionPopupDisplay?: MentionPopupDisplayMode;
  CustomMentionPopup: React.ComponentType<any>;
  onSelect: (user: User) => void;
  onClose: () => void;
}

export const MentionPopupLayer: React.FC<MentionPopupLayerProps> = ({
  enableMentions,
  isOpen,
  users,
  loading,
  selectedIndex,
  position,
  query,
  mentionPopupStyle,
  mentionPopupDisplay,
  CustomMentionPopup,
  onSelect,
  onClose
}) => {
  if (!enableMentions || !isOpen) return null;

  return (
    <CustomMentionPopup
      users={users}
      loading={loading}
      selectedIndex={selectedIndex}
      position={position}
      query={query}
      style={mentionPopupStyle}
      placement={position.placement}
      displayMode={mentionPopupDisplay}
      onSelect={onSelect}
      onClose={onClose}
    />
  );
};
